var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page page-404"},[_c('h1',{staticClass:"h2"},[_vm._v("404")]),_c('h2',{staticClass:"h3"},[_vm._v("Страница не найдена")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("На главную")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }